import React, { ReactNode, useMemo, useState } from 'react';
import EmbedContext from './EmbedContext';

interface EmbedProviderProps {
  children: ReactNode;
}

function EmbedProvider({ children }: EmbedProviderProps): React.ReactElement {
  const [embedIsReady, setEmbedIsReady] = useState<boolean>(false);
  const [contextChatbotUuid, setContextChatbotUuid] = useState<string | null>(
    null
  );

  const value = useMemo(
    () => ({
      embedIsReady,
      setEmbedIsReady,
      contextChatbotUuid,
      setContextChatbotUuid
    }),
    [embedIsReady, setEmbedIsReady, contextChatbotUuid, setContextChatbotUuid]
  );
  return (
    <EmbedContext.Provider value={value}>{children}</EmbedContext.Provider>
  );
}

export default EmbedProvider;
